import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field, FieldArray } from 'redux-form';

import InputField from '../../../shared/form-elements/input';
import Textarea from '../../../shared/form-elements/textarea';
import SelectField from '../../../shared/form-elements/select/field';
import Checkbox from '../../../shared/form-elements/checkbox';

const Form = ({
	intl,
	locationsLookups,
	updateFeatureFlagsJsonDelayed,
	canEditFeatureFlagsManually,
	handleSubmit,
	featureFlags,
	submitFeatureFlagsForm
}) => (
	<form className="ui-form affiliate-main__form" onSubmit={handleSubmit(data => submitFeatureFlagsForm(data))}>
		<div className="ui-form__element">
			<div className='ui-form__element display-inline-block width-100-p'>
				<Field
					name="can_edit_feature_flags_manually"
					placeholder={intl('Edit feature flags manually')}
					component={Checkbox}
					showLabel={true}
					initialValue={false}
				/>
			</div>
			<div className='ui-form__element display-inline-block width-100-p'>
				<Field
					name="is_contest_included"
					placeholder={intl('Taking part in contest?')}
					component={Checkbox}
					showLabel={true}
					initialValue={false}
					onChange={updateFeatureFlagsJsonDelayed}
				/>
			</div>
			<div className='ui-form__element display-inline-block width-100-p'>
				<Field
					name={`feature_flags_JSON`}
					component={Textarea}
					showLabel={true}
					disabled={!canEditFeatureFlagsManually}
					initialValue={featureFlags}
				/>
			</div>
			<FieldArray
				name="antiduble_rules"
				intl={intl}
				component={TemplatesField}
				updateFeatureFlagsJsonDelayed={updateFeatureFlagsJsonDelayed}
				featureFlags={featureFlags}
				locationsLookups={locationsLookups}
				placeholder={ intl('Antibuble rules') }
			/>
		</div>
	</form>
);

function TemplatesField(props) {
	const { intl, fields, updateFeatureFlagsJsonDelayed, locationsLookups } = props;

	return (
		<div className='ui-form affiliate-feature-flags__form'>
			<table className="simple-table max-width-700">
				<thead className="simple-table__head font-roboto-medium">
					{
						!!fields.length &&
					<tr>
						<th>Location</th>
						<th className="padding-0-15">Offer_id</th>
						<th className="padding-0-15">Campaign_id</th>
						<th className="padding-0-15">Action</th>
					</tr>
					}
				</thead>
				<tbody className="simple-table__head font-roboto-medium">
					{fields.map((name, index) => (
						<tr className='' key={index} >
							<td className='ui-form__element width-300'>
								<Field
									name={`${name}.country_id`}
									placeholder={intl('Select country')}
									component={SelectField}
									multi={false}
									showLabel={false}
									options={locationsLookups}
									onChange={updateFeatureFlagsJsonDelayed}
								/>
							</td>
							<td className='ui-form__element padding-5-15'>
								<Field
									name={`${name}.offer_id`}
									component={InputField}
									showLabel={false}
									onChange={updateFeatureFlagsJsonDelayed}
								/>
							</td>
							<td className='ui-form__element padding-5-15'>
								<Field
									name={`${name}.campaign_id`}
									component={InputField}
									showLabel={false}
									onChange={updateFeatureFlagsJsonDelayed}
								/>
							</td>
							<td className="flex-center">
								<span
									className="action_delete--button margin-top-15"
									onClick={() => {
										if (confirm('You want to remove untiduble rule?')) {
											fields.remove(index);
											updateFeatureFlagsJsonDelayed();
										}
									}}
								/>
							</td>
						</tr>
					))}
				</tbody>
			</table>
			<div className="display-flex margin-top-20">
				<div className="ui-form__element">
					<button
						className='ui-btn ui-btn-secondary'
						type='button'
						onClick={() => fields.push({ offer_id: null, country_id: null, campaign_id: null })}
					>
						{intl('Аdd antiduble rule')}
					</button>
				</div>
				<div className="ui-form__element">
					<button className="ui-btn ui-btn-primary margin-0-15 margin-top-0">{ intl('Edit') }</button>
				</div>
			</div>
		</div>
	);
}

Form.propTypes = {
	intl: PropTypes.func,
	submitFeatureFlagsForm: PropTypes.func,
	handleSubmit: PropTypes.func
};

export default reduxForm({
	form: 'affiliateFeatureFlagsForm'
})(Form);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/form/feature-flags.js